export default {"src":"/login-app/[GIT_HASH]/_next/static/media/role_launcher.edd9613c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};